<template>
  <div id="app">
    <BApp>
      <main class="container">
        <Messenger :current-user="currentUser" />
      </main>
    </BApp>
  </div>
</template>

<script>
import Messenger from './components/Messenger.vue'
import {BApp} from 'bootstrap-vue-next'

export default {
  name: 'App',
  components: {
    Messenger,
    BApp,
  },
  data() {
    const userEl = document.getElementById('current-user')
    const userId = userEl ? userEl.dataset.userId : 0
    const userName = userEl ? userEl.dataset.userName : 'Unknown'

    return {
      currentUser: {
        id: userId,
        name: userName,
        avatar: null,
      }
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-sont-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  background-color: #f8f9fa;
}

.container {
  max-width: 1200px;
}
</style>
